import anime from 'animejs/lib/anime.es.js';

export default class svgMotion {
  constructor() {
    this.init();
  }
  init() {
    let shapes = [
      {
        d:"M39.5 47.5C39.5 47.5 24.5001 28 5.04243 6.60723C-14.4152 -14.7855 -258.134 -102.199 -340.149 16.9808L-356.273 40.4104C-387.429 85.6847 -401.731 140.447 -396.691 195.174L-396.691 792C-379.519 978.492 6.75405 724.653 17.877 717.577C29 710.5 42.5 702 61.5 681C80.5 660 101.5 543 92.5 485.5C83.5 428 43.6849 400.5 58.9672 348.12C74.2494 295.74 22.3542 245.171 46.5118 196.055C71.6673 144.909 74.5728 92.4284 39.5 47.5Z"
      },
      {
        d: "M73.0001 60.5C73.0001 60.5 17.0424 5.10723 -9.99999 -5C-37.0424 -15.1072 -258.134 -102.199 -340.149 16.9808L-356.273 40.4103C-387.429 85.6846 -401.731 140.447 -396.691 195.174L-396.691 792C-379.518 978.492 6.75412 724.653 17.8771 717.577C29.0001 710.5 74.0001 679.5 85.5001 634C97.0001 588.5 21.1374 524.335 61.5001 465C101.863 405.665 93.3281 348.031 61.5001 303.5C29.6721 258.969 22.3543 245.171 46.5118 196.055C71.6673 144.909 108.073 105.428 73.0001 60.5Z"
      },
      {
        d:"M103.5 48C60.0001 -0.500035 17.0424 5.10724 -9.99999 -5C-37.0424 -15.1072 -258.134 -102.199 -340.149 16.9808L-356.273 40.4103C-387.429 85.6846 -401.731 140.447 -396.691 195.174L-396.691 792C-379.518 978.492 -58.6229 752.077 -20.5 736C17.6229 719.923 107 749 114 652.5C121 556 -7.86271 523.335 32.5 464C72.8627 404.665 78.3398 369.531 46.5118 325C14.6838 280.469 68.9882 235.945 83 213.5C97.0118 191.055 147 96.5 103.5 48Z"
      }
    ]
    
    let morph = anime({
      targets: '.st0',
      d: [
            {value: [
              shapes[0].d,
              shapes[1].d
            ]},
            {value: shapes[2].d},
            {value: shapes[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });

    let shapes2 = [
      {
        d:"M182.825 507.432L206.405 522.396C289.534 575.151 399.971 531.995 425.305 436.855L430.286 418.152C439.91 382.01 436.562 343.638 420.824 309.709L321.981 96.6153C268.351 -19.0032 107 -3.05946 78 8.49997C49 20.0594 16 46 5.5 93.5C-5 141 5.5 228.5 38.5 269C71.5 309.5 84.5 316 109 334C133.5 352 140.526 391.936 135.5 418C130.474 444.064 150.075 486.648 182.825 507.432Z"
      },
      {
        d: "M182.825 507.432L206.405 522.396C289.534 575.151 399.971 531.995 425.305 436.855L430.286 418.152C439.91 382.01 436.562 343.638 420.824 309.709L321.981 96.6153C268.351 -19.0032 206.405 45.5 135.5 24C64.5946 2.49997 44.4632 85.5 37.5 117C30.5368 148.5 54.5 199.5 87.5 240C120.5 280.5 111 327.5 135.5 345.5C160 363.5 153.526 410.792 148.5 436.855C143.474 462.919 150.075 486.648 182.825 507.432Z"
      },
      {
        d:"M182.825 507.432L206.405 522.396C289.534 575.151 399.971 531.995 425.305 436.855L430.286 418.152C439.91 382.01 436.562 343.638 420.824 309.709L321.981 96.6153C268.351 -19.0032 181 25 144 17C107 9 75.5 59.5 37 88.5C-1.5 117.5 25.5 219.5 49 248.5C72.5 277.5 77.5 339 59.5 364.5C41.5 390 67.5 422.5 59.5 446C51.5 469.5 106 498.5 182.825 507.432Z"
      }
    ]
    
    let morph2 = anime({
      targets: '.st1',
      d: [
            {value: [
              shapes2[0].d,
              shapes2[1].d
            ]},
            {value: shapes2[2].d},
            {value: shapes2[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });

    let shapes3 = [
      {
        d:"M9.99987 107C0.999894 142 -6.00015 226 9.99987 281.5C25.9999 337 85.9999 375 125.5 383C165 391 211.173 396.054 240.087 391.027C269 386 381.66 392.402 407.33 400.201C433 408 520.299 445.93 556.399 445.715C592.5 445.5 636.731 441.488 663 435.5C735.063 419.073 754 333.5 759 294.159C764 254.818 741.5 207 744.5 161C747.5 115 648.084 45.2658 612.5 43.5001C576.916 41.7344 519.5 50.5001 508.849 52.7305C498.198 54.9609 392.5 56 364.697 46.3989C336.894 36.7977 320.5 12.5178 245.5 6.25896C170.5 8.10623e-05 141 3.01784 103.5 6.25897C65.9999 9.5001 18.9998 72 9.99987 107Z"
      },
      {
        d: "M43.9999 135C35 170 -8 226 8.00002 281.5C24 337 31.0002 396 101.5 407C172 418 219 372 251.5 371C284 370 352.83 407.701 378.5 415.5C404.17 423.299 518.299 445.93 554.4 445.715C590.5 445.5 625.5 430.701 669 400.201C712.5 369.701 702.5 363 727.5 323.5C752.5 284 710 239.5 713 193.5C716 147.5 677 91 636.5 87C596 83 566 54.5 506.849 52.7305C447.698 50.9609 406.303 91.1011 378.5 81.5C350.697 71.8989 318.5 12.5178 243.5 6.25893C168.5 4.8697e-05 171.5 46.3988 120 43.5C68.5 40.6012 52.9999 100 43.9999 135Z"
      },
      {
        d:"M16.9999 112.5C7.99988 147.5 29.5 227 45.5 282.5C61.5 338 4.99988 395.5 60.5 422.5C116 449.5 220 416.5 252.5 415.5C285 414.5 352.83 431.701 378.5 439.5C404.17 447.299 470.399 415.715 506.5 415.5C542.6 415.285 598.5 394.799 627.5 386.5C656.5 378.201 700 362 701 327.5C702 293 677 259.5 680 213.5C683 167.5 734.5 93.5 701 32.5C667.5 -28.5 582.651 24.2695 523.5 22.5C464.349 20.7305 421.303 42.1012 393.5 32.5C365.697 22.8989 318.5 12.5178 243.5 6.25894C168.5 6.00815e-05 171.5 46.3988 120 43.5C68.4999 40.6012 25.9998 77.5 16.9999 112.5Z"
      }
    ]
    
    let morph3 = anime({
      targets: '.st2',
      d: [
            {value: [
              shapes3[0].d,
              shapes3[1].d
            ]},
            {value: shapes3[2].d},
            {value: shapes3[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });

    let shapes4 = [
      {
        d:"M-391.345 -208.838L-417.342 -179.785C-498.979 -88.5491 -477.539 54.4333 -372.733 117.713L-367.099 121.114C-318.6 150.397 -277.931 191.011 -248.583 239.471L-167.843 372.792C-153.886 395.838 -134.143 414.831 -110.574 427.885C-45.9166 463.697 61 432 95 406C129 380 141.79 371.996 164.5 323.5C187.21 275.004 170.5 116.5 138 93C105.5 69.5 69.5 32 37.5 22C5.50001 12 -16.779 -12.7288 -44.4329 -52.6177L-142.788 -194.488C-154.969 -212.058 -170.643 -226.924 -188.832 -238.159C-254.526 -278.735 -339.857 -266.38 -391.345 -208.838Z"
      },
      {
        d: "M-391.345 -208.838L-417.342 -179.785C-498.979 -88.5491 -477.539 54.4333 -372.733 117.713L-367.099 121.114C-318.6 150.397 -277.931 191.011 -248.583 239.471L-167.843 372.792C-153.886 395.838 -134.143 414.831 -110.574 427.885C-45.9166 463.697 4.50003 447 38.5 421C72.5 395 33.5 306.5 51.5 250.5C69.5 194.5 124.5 185.5 109.5 144C94.5 102.5 69.5 32 37.5 22C5.50001 12 -16.779 -12.7288 -44.4329 -52.6177L-142.788 -194.488C-154.969 -212.058 -170.643 -226.924 -188.832 -238.159C-254.526 -278.735 -339.857 -266.38 -391.345 -208.838Z"
      },
      {
        d:"M-391.345 -208.838L-417.342 -179.785C-498.979 -88.5491 -477.539 54.4333 -372.733 117.713L-367.099 121.114C-318.6 150.397 -277.931 191.011 -248.583 239.471L-167.843 372.792C-153.886 395.838 -134.143 414.831 -110.574 427.885C-45.9166 463.697 -29 489 8.00001 432.5C45 376 93.5 405 116 361.5C138.5 318 99.5 239 65.5 181.5C31.5 124 108.5 80 56 43.5C3.5 7 -16.779 -12.7288 -44.4329 -52.6177L-142.788 -194.488C-154.969 -212.058 -170.643 -226.924 -188.832 -238.159C-254.526 -278.735 -339.857 -266.38 -391.345 -208.838Z"
      }
    ]
    
    let morph4 = anime({
      targets: '.st3',
      d: [
            {value: [
              shapes4[0].d,
              shapes4[1].d
            ]},
            {value: shapes4[2].d},
            {value: shapes4[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });

    let shapes5 = [
      {
        d:"M27.5001 102C-4.49997 134.5 3.97712e-05 206.5 3.97712e-05 308.5C3.97712e-05 410.5 146 464.457 180.5 468.478C215 472.5 250.087 461.305 275.5 455.5C300.914 449.695 351.146 451.935 405.33 468.478L554.4 513.993C580.168 521.86 607.547 522.849 633.816 516.861C705.879 500.434 757 436.349 757 362.437V268.571C757 171.326 670.615 96.7802 574.416 111.012L506.849 121.008C458.835 128.112 406 117.5 362.697 114.677C319.394 111.853 285.201 95.9634 246 88.0001C206.799 80.0368 165.5 60.4996 130 62.9998C94.5001 65.5001 59.5001 69.5 27.5001 102Z"
      },
      {
        d: "M18.0001 114.676C-13.9999 147.176 76.0001 223.5 18.0001 324C-39.9998 424.5 61.9999 496.978 96.4999 501C131 505.021 194.5 513.993 264 501C333.5 488.007 351.145 451.935 405.33 468.478L554.399 513.993C580.168 521.86 607.546 522.849 633.815 516.861C705.879 500.434 757 436.349 757 362.437V268.571C757 171.325 670.615 96.78 574.416 111.012L506.849 121.008C458.834 128.112 406 117.5 362.697 114.676C319.394 111.853 285.201 95.9633 246 88C206.799 80.0366 171.5 46.9997 136 49.5C100.5 52.0003 50.0002 82.1765 18.0001 114.676Z"
      },
      {
        d:"M78.4998 66.5001C58.4996 99.0001 126.5 203.5 113.5 255.5C100.5 307.5 52.9999 371 88.4999 414.5C124 458 140.5 515.993 210 503C279.5 490.007 351.146 451.935 405.33 468.479L554.399 513.993C580.168 521.86 607.546 522.849 633.815 516.861C705.879 500.434 757 436.349 757 362.437V268.571C757 171.325 670.615 96.7801 574.416 111.012L506.849 121.008C458.835 128.112 422.303 90.3235 379 87.5C335.698 84.6765 318.701 122.64 279.5 114.677C240.299 106.713 255.5 68.9999 210 39.5C164.5 10.0001 98.5 34.0001 78.4998 66.5001Z"
      }
    ]
    
    let morph5 = anime({
      targets: '.st4',
      d: [
            {value: [
              shapes5[0].d,
              shapes5[1].d
            ]},
            {value: shapes5[2].d},
            {value: shapes5[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });

    let shapes6 = [
      {
        d:"M360.825 507.431C377 512.5 401.905 527.395 416 529.499C430.095 531.602 577.971 531.994 603.306 436.855L608.286 418.151C617.91 382.009 614.562 343.638 598.825 309.709L499.981 96.6146C446.351 -19.004 299.5 3.99785 271 14.9981C242.5 25.9983 215 45.4985 188.5 88.9985C162 132.499 170.318 227.499 198 269.499C225.682 311.499 262.289 315.307 274.501 330.999C286.713 346.691 314.026 393.935 310.5 423.499C306.974 453.062 344.651 502.362 360.825 507.431Z"
      },
      {
        d: "M355.5 505.5C393.5 501 401.904 527.395 416 529.498C430.095 531.601 577.97 531.993 603.305 436.854L608.286 418.15C617.91 382.009 614.562 343.637 598.824 309.708L499.981 96.6139C446.351 -19.0047 359 57.4998 330.5 68.5C302 79.5002 258 56.9998 231.5 100.5C205 144 191.818 207 219.5 249C247.182 291 303.288 310.808 315.5 326.5C327.712 342.191 267.5 359 267.5 418.15C267.5 477.301 317.5 510 355.5 505.5Z"
      },
      {
        d:"M332.5 470.499C351.5 492.999 401.905 527.394 416 529.498C430.095 531.601 577.971 531.993 603.306 436.854L608.286 418.15C617.91 382.008 614.562 343.637 598.825 309.708L499.981 96.6136C446.351 -19.0049 354 16.4993 309.5 21.4992C265 26.4992 256 -3.50074 190.5 68.4993C125 140.499 260.5 141.499 232.5 198.999C204.5 256.499 215 292.999 226.5 332.499C238 371.999 206 364.15 226.5 418.15C247 472.15 313.5 447.999 332.5 470.499Z"
      }
    ]
    
    let morph6 = anime({
      targets: '.st5',
      d: [
            {value: [
              shapes6[0].d,
              shapes6[1].d
            ]},
            {value: shapes6[2].d},
            {value: shapes6[0].d}
        ],
        // fill:['#85f573','#73b0f5','#FF0000'],
        duration: 20000,
        autoplay: true,
        easing: 'linear',
        loop: true
    });
  }
}